import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

interface AssistentBannerProps {
  variant?: "inline" | "strip";
  className?: string;
}

/**
 * Kleine banner/link die verwijst naar de AI-assistent.
 * - "inline": subtiele regel tekst met link (voor in hero's en CTA-secties)
 * - "strip": lichte balk, geschikt als tussensectie
 */
export function AssistentBanner({ variant = "inline", className = "" }: AssistentBannerProps) {
  if (variant === "strip") {
    return (
      <section className={`border-t border-b border-border bg-muted/40 py-5 ${className}`}>
        <div className="container-wide flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3 text-sm text-muted-foreground">
            <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Sparkles className="h-4 w-4 text-primary" />
            </div>
            <span>
              Nog niet zeker wat je nodig hebt?{" "}
              <span className="font-medium text-foreground">Even sparren met onze AI-assistent.</span>
            </span>
          </div>
          <Link
            to="/online-sale-specialist-assistent"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline whitespace-nowrap"
          >
            Start een gesprek
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    );
  }

  // inline variant
  return (
    <Link
      to="/online-sale-specialist-assistent"
      className={`inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors group ${className}`}
    >
      <Sparkles className="h-3.5 w-3.5 text-primary-foreground flex-shrink-0" />
      <span>
        Snel antwoord nodig?{" "}
        <span className="font-medium text-foreground group-hover:underline">
          Stel je vraag aan de Online Sale Specialist Assistent.
        </span>
      </span>
      <ArrowRight className="h-3.5 w-3.5 text-primary opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
    </Link>
  );
}
